import PropTypes from 'prop-types';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';

function PercentChangeIndicator({ percent = null }) {
  const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    useGrouping: true,
    signDisplay: 'always',
  });
  const positive = Number(percent) >= 0;
  const isNumber = typeof percent === 'number';
  return isNumber ? (
    <div className={`percent-change-indicator ${positive ? 'positive' : 'negative'}`}>
      <span className="percent">{isNumber ? `${formatter.format(percent)}%` : '-'}</span>
      <span className="arrow">
        {positive ? (
          <IoMdArrowDropup color="green" size={20} />
        ) : (
          <IoMdArrowDropdown color="red" size={20} />
        )}
      </span>
    </div>
  ) : null;
}

PercentChangeIndicator.propTypes = {
  percent: PropTypes.number.isRequired,
};

export default PercentChangeIndicator;
